module.exports = __webpack_public_path__ + "img/thumbnail-squirell.a369e320.jpg";